import React from 'react'

function AppointmnetBooking() {
    return (
        <div>
            Appointment Booking page
        </div>
    )
}

export default AppointmnetBooking
